import { EnumsValues } from '../enums/EnumsValues';

export const truncateDecimals = (value: number, decimals: number): number => {
  const factor = Math.pow(EnumsValues.ConstNumbers.ten, decimals);
  return Math.floor(value * factor) / factor;
};
